var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLearning2 = function SvgLearning2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232322",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1.333 30.667h29.334M11.366 3.98a8.93 8.93 0 0 0 6.427 2.73c1.216.001 2.42-.246 3.537-.727m1.189 10.994a8.703 8.703 0 0 0-13.037 0m14.251 13.689H8.27l-2.01-9.086a1.49 1.49 0 0 1 .216-1.154 1.15 1.15 0 0 1 .938-.521h17.175a1.15 1.15 0 0 1 .94.521 1.48 1.48 0 0 1 .216 1.154zM14.044 24.8a1.955 1.955 0 1 0 3.91 0 1.955 1.955 0 0 0-3.91 0M10.622 6.71a5.378 5.378 0 1 0 10.755 0 5.378 5.378 0 0 0-10.755 0",
    vectorEffect: "non-scaling-stroke"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgLearning2;